function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_111_",
    style: {
      fill: "#FFFFFF",
      fillOpacity: 0
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_163_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_329_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    style: {
      fill: "#DFF3FC"
    },
    d: "M430.53,409.572c47.49-36.11,68.64-136.24-8.47-185.34 c-51.05-32.5-82.8-13.96-140.23-35.46c-70.11-26.24-80.56-105.52-165.84-66.51c-45.18,20.66-76.5,78.89-82.01,145.07 c-5.4,64.81,17.57,109.28,64.51,139.71C208.72,411.732,319.17,410.882,430.53,409.572z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    style: {
      fill: "#DFF3FC"
    },
    d: "M235.432,124.76c-7.173,28.8,19.464,57.31,47.526,69.13 c28.063,11.83,60.243,10.42,90.307,4.78c12.972-2.43,26.307-5.85,36.384-14.12c10.078-8.27,15.92-22.63,10.397-34.23 c-4.874-10.23-16.74-15.47-28.052-18.16c-11.312-2.69-23.327-3.79-33.405-9.45c-9.556-5.37-16.335-14.26-24.646-21.3 c-15.356-12.99-36.927-19.43-56.891-15.32C257.077,90.2,241.529,100.28,235.432,124.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_162_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_160_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_155_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M450.295,257.226v-21.788h-8.262c-0.992-3.809-2.505-7.401-4.443-10.71 l5.842-5.851l-15.408-15.408l-5.851,5.842c-3.308-1.938-6.9-3.45-10.71-4.443v-8.261h-21.788v8.261 c-3.809,0.993-7.401,2.505-10.71,4.443l-5.851-5.842l-15.408,15.408l5.842,5.851c-1.938,3.308-3.441,6.9-4.443,10.71h-8.261 v21.788h8.261c1.002,3.809,2.505,7.401,4.443,10.71l-5.842,5.851l15.408,15.408l5.851-5.842c3.308,1.938,6.9,3.441,10.71,4.443 v8.261h21.788v-8.261c3.809-1.002,7.401-2.505,10.71-4.443l5.851,5.842l15.408-15.408l-5.842-5.851 c1.938-3.308,3.45-6.9,4.443-10.71H450.295z M400.576,265.209c-10.428,0-18.883-8.455-18.883-18.883 c0-10.417,8.455-18.871,18.883-18.871c10.417,0,18.871,8.454,18.871,18.871C419.447,256.755,410.993,265.209,400.576,265.209z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    style: {
      fill: "none",
      stroke: "#A2C7EB",
      strokeMiterlimit: 10
    },
    d: "M384.455,311.817l-4.145-10.805l-4.097,1.572 c-1.217-1.7-2.65-3.194-4.241-4.466l1.784-4.013l-10.572-4.71l-1.79,4.01c-2.009-0.332-4.078-0.398-6.156-0.166l-1.572-4.097 l-10.805,4.145l1.572,4.097c-1.7,1.217-3.194,2.65-4.466,4.241l-4.013-1.784l-4.71,10.572l4.01,1.79 c-0.331,2.009-0.393,4.077-0.166,6.156l-4.097,1.572l4.145,10.805l4.097-1.572c1.222,1.699,2.65,3.194,4.241,4.466 l-1.784,4.013l10.572,4.71l1.79-4.01c2.009,0.332,4.077,0.393,6.156,0.166l1.572,4.097l10.805-4.145l-1.572-4.097 c1.699-1.222,3.194-2.65,4.466-4.241l4.013,1.784l4.71-10.572l-4.01-1.79c0.332-2.009,0.398-4.078,0.166-6.156L384.455,311.817 z M361.317,325.236c-5.171,1.984-10.973-0.6-12.957-5.772c-1.982-5.166,0.602-10.967,5.774-12.951 c5.166-1.982,10.967,0.603,12.949,5.768C369.067,317.452,366.483,323.254,361.317,325.236z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    style: {
      fill: "none",
      stroke: "#A2C7EB",
      strokeMiterlimit: 10
    },
    d: "M349.053,273.917l-2.801-7.301l-2.768,1.062 c-0.822-1.149-1.791-2.158-2.866-3.018l1.205-2.712l-7.144-3.182l-1.21,2.71c-1.358-0.224-2.756-0.269-4.16-0.112l-1.062-2.768 l-7.301,2.801l1.062,2.768c-1.149,0.822-2.158,1.791-3.018,2.865l-2.712-1.205l-3.182,7.144l2.71,1.21 c-0.224,1.358-0.266,2.755-0.112,4.16l-2.768,1.062l2.801,7.301l2.768-1.062c0.826,1.148,1.791,2.158,2.866,3.018l-1.205,2.712 l7.144,3.182l1.21-2.71c1.358,0.224,2.755,0.266,4.16,0.112l1.062,2.768l7.301-2.801l-1.062-2.768 c1.148-0.825,2.158-1.791,3.017-2.865l2.712,1.205l3.182-7.144l-2.71-1.21c0.224-1.358,0.269-2.756,0.112-4.16L349.053,273.917 z M333.419,282.983c-3.494,1.34-7.414-0.406-8.755-3.9c-1.339-3.491,0.407-7.41,3.901-8.751c3.49-1.339,7.41,0.407,8.749,3.898 C338.656,277.724,336.909,281.644,333.419,282.983z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    style: {
      fill: "#0097D8",
      stroke: "#0097D8",
      strokeMiterlimit: 10
    },
    d: "M346.511,146.088 c0,10.948-5.117,20.707-13.078,27.013c-5.862,4.652-13.274,7.412-21.348,7.412c-8.053,0-15.466-2.76-21.348-7.412 c-7.971-6.306-13.078-16.065-13.078-27.013c0-19.012,15.414-34.426,34.426-34.426 C331.097,111.662,346.511,127.076,346.511,146.088z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_32_",
    transform: "matrix(0.9925 -0.1225 0.1225 0.9925 -14.1588 39.2505)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 312.085,
    cy: 134.757,
    rx: 11.269,
    ry: 11.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M333.433,168.759c-5.862,4.652-13.274,7.413-21.348,7.413 c-8.053,0-15.466-2.76-21.348-7.413c2.202-9.687,4.228-18.05,6.337-20.169c2.977-2.977,10.886-4.714,15-4.714 s12.395,2.109,13.925,3.639C329.122,150.626,331.81,159.217,333.433,168.759z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    style: {
      fill: "#0097D8"
    },
    d: "M262.61,230.952v-17c0-4.64,3.76-8.4,8.4-8.4h53.56c4.64,0,8.4,3.76,8.4,8.4v17 c0,4.64-3.76,8.4-8.4,8.4h-53.55C266.38,239.362,262.61,235.592,262.61,230.952z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_37_",
    style: {
      fill: "#0097D8"
    },
    points: "285.23,230.062 259.31,255.312 301.32,234.082  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M269.11,213.532v-0.09c0-0.69,0.56-1.25,1.25-1.25h26.48 c0.69,0,1.25,0.56,1.25,1.25v0.09c0,0.69-0.56,1.25-1.25,1.25h-26.48C269.67,214.782,269.11,214.222,269.11,213.532z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.28,213.532v-0.09c0-0.69,0.56-1.25,1.25-1.25h23.11 c0.69,0,1.25,0.56,1.25,1.25v0.09c0,0.69-0.56,1.25-1.25,1.25h-23.11C299.84,214.782,299.28,214.222,299.28,213.532z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M289.19,219.222v-0.09c0-0.69,0.56-1.25,1.25-1.25h33.2 c0.69,0,1.25,0.56,1.25,1.25v0.09c0,0.69-0.56,1.25-1.25,1.25h-33.2C289.75,220.472,289.19,219.912,289.19,219.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M269.11,219.222v-0.09c0-0.69,0.56-1.25,1.25-1.25h14.83 c0.69,0,1.25,0.56,1.25,1.25v0.09c0,0.69-0.56,1.25-1.25,1.25h-14.83C269.67,220.472,269.11,219.912,269.11,219.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M293.8,224.912v-0.09c0-0.69,0.56-1.25,1.25-1.25h28.59 c0.69,0,1.25,0.56,1.25,1.25v0.09c0,0.69-0.56,1.25-1.25,1.25h-28.59C294.36,226.162,293.8,225.602,293.8,224.912z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M269.11,224.912v-0.09c0-0.69,0.56-1.25,1.25-1.25h19.75 c0.69,0,1.25,0.56,1.25,1.25v0.09c0,0.69-0.56,1.25-1.25,1.25h-19.75C269.67,226.162,269.11,225.602,269.11,224.912z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M269.11,230.602v-0.09c0-0.69,0.56-1.25,1.25-1.25h7.33 c0.69,0,1.25,0.56,1.25,1.25v0.09c0,0.69-0.56,1.25-1.25,1.25h-7.33C269.67,231.852,269.11,231.292,269.11,230.602z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.53,230.602v-0.09c0-0.69,0.56-1.25,1.25-1.25h40.86 c0.69,0,1.25,0.56,1.25,1.25v0.09c0,0.69-0.56,1.25-1.25,1.25h-40.86C282.09,231.852,281.53,231.292,281.53,230.602z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_28_",
    transform: "matrix(0.4219 -0.9067 0.9067 0.4219 -116.8819 202.5268)",
    style: {
      fill: "#0097D8"
    },
    cx: 100.368,
    cy: 192.915,
    rx: 33.12,
    ry: 33.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1_",
    transform: "matrix(0.9435 -0.3314 0.3314 0.9435 -64.0872 42.4944)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 92.563,
    cy: 209.171,
    rx: 8.026,
    ry: 8.026
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_17_",
    style: {
      fill: "#0097D8"
    },
    points: "88.349,212.051 87.961,206.961 92.176,204.081 96.778,206.29  97.165,211.38 92.951,214.261  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_23_",
    transform: "matrix(0.9416 -0.3366 0.3366 0.9416 -53.1546 46.7234)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 108.173,
    cy: 176.659,
    rx: 8.026,
    ry: 8.026
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_22_",
    style: {
      fill: "#0097D8"
    },
    points: "104.192,179.054 104.468,172.582 109.345,168.319 113.947,170.529  113.671,177.001 108.793,181.263  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M98.122,205.461l-6.139-2.948l4.537-10.467 c0.288-0.664,0.601-1.317,0.939-1.957l5.331-10.086l6.139,2.948l-4.376,10.308c-0.338,0.797-0.714,1.578-1.124,2.341 L98.122,205.461z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    style: {
      fill: "#0097D8"
    },
    d: "M123.374,210.734c1.183-0.549,20.186,0.318,20.186,0.318l-13.698-12.576 L123.374,210.734z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_159_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_74_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_157_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_166_",
    transform: "matrix(0.397 -0.9178 0.9178 0.397 -6.8524 237.5465)",
    style: {
      fill: "#0097D8"
    },
    cx: 177.363,
    cy: 123.988,
    rx: 32.553,
    ry: 32.553
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_158_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_72_",
    x: 176.276,
    y: 96.247,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.174,
    height: 27.338
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_73_",
    x: 164.265,
    y: 118.51,
    transform: "matrix(-0.5691 -0.8222 0.8222 -0.5691 150.6231 343.6579)",
    style: {
      fill: "#FFFFFF"
    },
    width: 2.174,
    height: 27.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_156_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M180.359,123.988c0,1.655-1.341,2.996-2.996,2.996 c-1.655,0-2.996-1.341-2.996-2.996c0-1.655,1.341-2.996,2.996-2.996C179.018,120.992,180.359,122.334,180.359,123.988z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_161_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_231_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M265.74,344.412c-1.93-29.76,11.09-60.56,33.02-78.18 C299.44,296.142,286.55,326.412,265.74,344.412z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M295.18,274.242 c-9.24,17.22-17.23,35.24-23.87,53.83c-8.07,22.57-14.42,46.55-28.24,65.47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M258.82,363.132c11.1-24.83,33.13-43.59,57.42-48.9 C305.9,340.842,282.64,361.142,258.82,363.132z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M310.28,319.702 c-16.59,14.6-33.46,28.79-50.61,42.56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_104_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M252.27,384.762c14.83-22.15,42.19-33.71,64.83-27.39 C300.45,379.242,273.03,390.832,252.27,384.762z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_103_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M311.67,358.972 c-19.44,12.16-40.41,21.14-62.03,26.54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_102_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M260.28,355.602c4.74-24.94-2.37-52.74-18.2-71.13 C235.59,308.982,241.78,337.702,260.28,355.602z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_101_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M243.71,290.832 c3.12,23.2,8.67,44.93,17.27,66.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_100_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M252.14,376.842c-2.02-25.64-15.16-49.72-34.38-63.01 c1.11,13.58,4.72,26.67,10.45,38.57C234.8,366.072,244.48,374.742,252.14,376.842z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_99_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M220.61,319.022 c7.56,21.38,18.44,41.2,32.01,58.36"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_98_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M400.57,370.692c10.49-27.29,34.62-49.43,61.23-56.17 C450.14,341.442,426.34,363.142,400.57,370.692z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M455.35,320.192 c-15.22,11.57-29.68,24.36-43.16,38.21c-16.38,16.82-31.83,35.58-51.8,46.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_96_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M386.78,384.542c19.99-17.59,47.15-25.31,70.79-20.13 C437.53,383.902,408.65,392.492,386.78,384.542z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_95_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M450.06,366.862 c-20.65,6.24-41.38,11.99-62.18,17.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_94_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M372.12,401.142c22.19-13.68,51.11-12.81,68.53,2.06 C416.97,415.882,387.98,415.012,372.12,401.142z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_93_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M435.2,402.402 c-22.16,2.9-44.39,2.34-65.7-1.67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M391.16,378.432c14.41-20.28,19.52-47.95,13.07-70.79 C388.44,326.822,382.14,354.932,391.16,378.432z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M403.06,313.962 c-6.76,21.94-10.75,43.56-11.85,66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M375.26,394.032c8.72-23.66,6.98-50.48-4.56-70.16 c-4.58,12.55-6.76,25.68-6.57,38.62C364.34,377.352,369.34,389.032,375.26,394.032z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_89_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M371.08,329.652 c-2.08,22.13-0.59,44.23,4.37,65.05"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_112_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M103.267,322.978c-10.694-32.709-40.537-59.138-75.254-66.638 C42.609,284.637,69.082,307.158,103.267,322.978z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M105.078,328.052c-23.425-13.247-52.775-16.168-78.218-7.794 C50.459,332.046,78.421,335.33,105.078,328.052z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M111.557,335.145c-25.317-3.509-51.829,2.732-72.39,17.037 C62.482,360.657,90.453,355.161,111.557,335.145z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_85_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M119.451,350.64c-25.071-0.104-49.721,11.811-64.457,31.158 c11.158,2.236,23.007,0.899,33.243-3.736C98.473,373.425,107.049,365.514,119.451,350.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M137.126,376.565c-24.721-4.238-51.061,3.422-68.886,20.037 c10.64,4.041,22.553,4.687,33.438,1.816C112.564,395.548,122.365,389.173,137.126,376.565z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M110.437,324.527c-16.324-22.003-20.754-51.653-11.48-76.877 c7.082,11.993,13.193,24.673,16.045,38.151C117.854,299.28,117.3,313.65,110.437,324.527z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    style: {
      fill: "#A2C7EB"
    },
    d: "M120.41,345.756c-3.866-23.377,4.127-48.153,21.01-65.083 C143.363,304.858,135.963,329.496,120.41,345.756z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_113_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M35.613,262.201 c49.684,31.789,88.54,79.172,109.051,133.006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M100.5,259.25 c6.043,24.539,9.72,49.592,10.964,74.719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M137.708,290.164 c-1.98,19.798-8.098,39.148-17.872,56.577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M37.318,320.829 c22.778,4.331,45.93,6.679,69.086,7.024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_77_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M51.044,350.237 c21.003-1.526,41.666-6.614,60.766-14.972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M63.627,378.266 c19.38-9.667,38.762-19.346,58.142-29.013"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    style: {
      fill: "none",
      stroke: "#6F8BBF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M76.232,395.337 c25.303-4.882,32.821-10.708,60.904-18.77"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_47_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    style: {
      fill: "#E06A58"
    },
    d: "M236.42,348.992c0,0,2.19,20.07,4.64,21.68c4.38,2.89,55.08,9.57,55.08,9.57 l-1.66,13.19c0,0-69.44,6.24-72.39,2.77c-5.12-6.02-14.12-35.06-14.12-35.06L236.42,348.992z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    style: {
      fill: "#F2AE30"
    },
    d: "M202.94,297.322l5.61-13.47c0,0,15.22,7.15,20.24,15.98 c5.37,9.44,11.94,59.63,11.94,59.63s-26.87,6.19-31.81,3.56C203.98,360.392,202.94,297.322,202.94,297.322z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    style: {
      fill: "#0A2240"
    },
    d: "M160.21,234.802c-3.93-1.44-8.09-2.7-12.3-2.38c-4.21,0.32-8.51,2.55-9.94,6.25 c-1.02,2.62-0.55,5.71-2.16,8.07c-1.54,2.26-4.6,3.2-7.46,3.39c-2.87,0.2-5.76-0.18-8.61,0.19 c-8.8,1.17-15.08,10.73-12.19,18.56c1.15,3.12,3.51,6.1,2.97,9.35c-0.57,3.48-4.22,5.77-5.72,9c-1.99,4.3,0.39,9.51,4.32,12.44 c3.93,2.92,9.04,4.03,14,4.77c6.83,1.02,13.88,1.5,20.63,0.06s13.2-5,16.69-10.56c1.55-2.46,2.49-5.24,4.29-7.55 c3.72-4.77,10.31-6.62,15.5-10c5.67-3.71,9.83-10.93,6.49-16.58c-3.22-5.43-11.6-6.64-14.96-11.99 c-1.39-2.21-1.72-4.84-2.62-7.25C168.22,238.152,166.02,236.932,160.21,234.802z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    style: {
      fill: "#F9A07B"
    },
    d: "M183.11,301.412c0.99,1.14,2.16,2.39,3.78,2.5c1.71,0.12,3.14-1.09,4.24-2.26 c5.68-6.01,9.43-13.39,10.95-21c-1.41-0.8-2.77-1.57-4-2.29c-1.14-0.68-2-1.63-2.49-2.74c-0.34-0.82-0.46-1.68-0.37-2.58 c0.8-7.52,1.51-11.71,4.15-19.34c-12.54-2.83-24.37-6.19-31.17-11.87c-0.83,3.5-1.81,10.35-3.9,17.14 c-2.23,7.19-5.71,14.3-11.61,17.36C164.27,283.172,174.6,291.672,183.11,301.412z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    style: {
      fill: "#E06A58"
    },
    d: "M195.22,273.052c-0.09,0.9,0.03,1.77,0.37,2.58c-7.42,9-24.01-2.76-31.29-16.65 c2.09-6.79,3.07-13.64,3.9-17.14c6.79,5.68,18.63,9.05,31.17,11.87C196.73,261.342,196.02,265.522,195.22,273.052z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    style: {
      fill: "#FFC73C"
    },
    d: "M215.88,381.852c-1.64,10.86,10.08,22.55,10.37,28.35 c-24.89,0-77.03,1.52-103.58-2.09c-1.21-6.7,11.9-21.77,11.9-36.65c0-1.97-0.08-4.13-0.24-6.45 c-0.42-6.64-1.4-14.54-2.49-22.64c-2.96-21.73-6.9-44.97-3.99-49.79c5.7-9.39,19.03-15.77,25.64-18.51 c2.27-0.94,3.75-1.45,3.86-1.51c8.29,14.14,25.16,26.2,31.53,25.66c1.77-0.14,7.02-1.97,10.49-19.44 c1.35,0.77,2.7,1.48,4.04,2.17c6.59,3.43,12.77,6.26,14.55,10.67c4.7,11.61,9.31,40.88,8.29,51.29 c-1.03,10.5-5.25,18.52-8.21,29.06c-0.69,2.47-1.32,5.09-1.83,7.91C216.08,380.512,215.98,381.172,215.88,381.852z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    style: {
      fill: "#FFBB33"
    },
    d: "M226.25,410.202c-24.89,0-77.03,1.52-103.58-2.09 c-1.21-6.7,11.9-21.77,11.9-36.65c0-1.97-0.08-4.13-0.24-6.45c-0.42-6.64-1.4-14.54-2.49-22.64 c4.71,4.97,11.58-16.03,14.62-9.88c16.45,33.2,29.42,41.93,51.96,41.93c6.72,0,12.92-0.93,19.62-2.45 c-0.69,2.47-1.32,5.09-1.83,7.91c-0.12,0.64-0.23,1.3-0.33,1.98C214.24,392.702,225.96,404.392,226.25,410.202z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    style: {
      fill: "#FCE172"
    },
    d: "M203.41,280.952c-1.07,7.77-4.24,18.24-13.46,21 c-12.46,3.73-30.49-19.55-36.46-27.88c2.27-0.94,3.75-1.45,3.86-1.51c8.29,14.14,25.16,26.2,31.53,25.66 c1.77-0.14,7.02-1.97,10.49-19.44C200.72,279.542,202.07,280.252,203.41,280.952z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_57_",
    style: {
      fill: "#325F73"
    },
    points: "208.53,398.512 208.44,407.182 363.44,408.102 363.76,398.272  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_56_",
    style: {
      fill: "#325F73"
    },
    points: "430.62,321.162 427.17,317.662 314.27,316.922 257.63,398.832  260.59,401.212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_55_",
    style: {
      fill: "#0B2D50"
    },
    points: "316.45,319.952 260.59,401.212 367.29,401.742 430.62,321.162  "
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_54_",
    style: {
      fill: "#3C738C"
    },
    cx: 343.41,
    cy: 365.612,
    rx: 12.42,
    ry: 6.21
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_114_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_115_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    style: {
      fill: "#56C4F9"
    },
    d: "M210.822,239.735c1.76-9.442,8.234-16.155,14.462-14.995 c6.228,1.161,9.85,9.755,8.09,19.197c-1.76,9.442-8.234,16.155-14.462,14.995 C212.685,257.772,209.063,249.177,210.822,239.735z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    style: {
      fill: "#0B2D50"
    },
    d: "M233.39,214.302c-1.16,8.22-4.83,17.28-10.18,27.29 c-1.88-8.2-3.08-18.19-4.74-28.18c-1.69-10.01-3.84-20.02-7.57-28.2c-0.84-1.81-1.75-3.54-2.74-5.14 c2.21-0.21,4.45,0,6.58,0.59c3.33,0.89,6.45,2.61,9,4.91c4.24,3.77,7.08,8.91,8.77,14.33 C233.9,204.402,234.15,209.182,233.39,214.302z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_118_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    style: {
      fill: "#F9A07B"
    },
    d: "M227.11,222.802c-0.06,1.62-0.17,3.27-0.32,4.91 c-2.28,26.6-13.45,44.85-30.54,44.85c-24.13,0-39.77-27.06-39.77-53.57c0-26.15,16.02-45.08,34.77-42.89 c10.81,1.24,18.71,4.83,24.32,10.09c3.71,3.5,6.39,7.73,8.22,12.54c2.09,5.39,3.1,11.49,3.31,18.06 c0,0.02,0.02,0.04,0.02,0.06C227.2,218.792,227.18,220.772,227.11,222.802z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    style: {
      fill: "#E06A58"
    },
    d: "M227.11,222.802c-0.72-2.57-1.79-5.08-3.25-7.33 c-14.23,7.44-31.19,10.31-47.27,7.59c-3.06,2.55-6.05,5.06-9.06,7.57c0.06-12.1,0.23-20.29,4.95-26.15 c4.43-5.5,11.82-7.57,18.82-8.47c7.88-1.03,15.89-0.99,23.75,0.15c3.01,0.42,6.13,1.07,8.75,2.59 c2.09,5.39,3.1,11.49,3.31,18.06c0,0.02,0.02,0.04,0.02,0.06C227.2,218.792,227.18,220.772,227.11,222.802z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    style: {
      fill: "#0B2D50"
    },
    d: "M230.59,206.422c-3.31,2.8-7.46,5.12-12.12,7 c-13.26,5.35-30.49,7.12-43.92,6.47c-6.6,14.5-9.27,19.7-10.96,32.35c-6.45-6.05-11.7-17.13-13.26-25.84 c-1.54-8.68-1.39-17.79,1.03-26.32c3.81-13.45,13.42-20.65,20.08-24.15c1.66-0.91,3.16-1.54,4.32-2 c8.51-3.29,18.1-2.99,26.83-0.32c4.76,1.48,8.77,3.98,12.14,7.06c6.81,6.15,11.02,14.48,13.74,20.72 C229.33,203.302,230.02,205.032,230.59,206.422z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_122_",
    style: {
      fill: "#225570"
    },
    d: "M233.39,214.302c-0.55-2.91-1.37-5.73-2.53-8.45 c-0.65-1.54-1.45-3.03-2.38-4.47c-3.03-4.76-7.44-8.68-12.77-10.41c-1.52-2.13-3.12-4.05-4.8-5.75 c-6.05-6.15-13.15-9.67-20.67-10.9c-6.26-1.01-12.77-0.44-18.78,1.6c1.66-0.91,3.16-1.54,4.32-2 c8.51-3.29,18.1-2.99,26.83-0.32c4.76,1.48,8.77,3.98,12.14,7.06c3.33,0.89,6.45,2.61,9,4.91c4.24,3.77,7.08,8.91,8.77,14.33 C233.9,204.402,234.15,209.182,233.39,214.302z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_123_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_124_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    style: {
      fill: "none",
      stroke: "#0B2D50",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M182.24,230.612c4.46-2.55,9.09-3.7,15.58-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_126_",
    style: {
      fill: "none",
      stroke: "#0B2D50",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M212.78,230.432c3.82-2.85,9.48-3.14,12.43,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    style: {
      fill: "none",
      stroke: "#CC454E",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M208.17,244.972c0.39,2.02,0.18,6.49-0.78,8.5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_128_",
    style: {
      fill: "#262D40"
    },
    cx: 193.1,
    cy: 243.432,
    rx: 1.84,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_129_",
    style: {
      fill: "#262D40"
    },
    cx: 217.15,
    cy: 242.082,
    rx: 1.84,
    ry: 2.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_130_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    style: {
      fill: "#CC454E"
    },
    d: "M205.89,257.422c0,0-0.36,0.7-1.05,1.65c-1.08,1.45-2.92,3.45-5.43,4.23 h-0.01c-1.06,0.34-2.21,0.46-3.49,0.23c-3.76-0.67-4.75-4.14-4.93-6.81c-0.04-0.52-0.04-1-0.03-1.44 c0.02-1.08,0.14-1.8,0.14-1.8C197.08,256.782,205.89,257.422,205.89,257.422z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M205.89,257.422c0,0-0.36,0.7-1.05,1.65c-3.06-0.04-9.32-1.61-13.89-3.79 c0.02-1.08,0.14-1.8,0.14-1.8C197.08,256.782,205.89,257.422,205.89,257.422z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    style: {
      fill: "#E8729B"
    },
    d: "M199.4,263.292c-1.06,0.34-2.21,0.46-3.49,0.23 c-3.76-0.67-4.75-4.14-4.93-6.81c1.82,0.22,3.58,0.92,5.04,2.03C197.55,259.912,198.72,261.502,199.4,263.292z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_134_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_135_",
    style: {
      fill: "#3D86E0"
    },
    d: "M163.65,226.022c0,0-0.21-12.47,4.98-24.86 c6.51-15.55,19.78-22.2,32.65-22.65c15.51-0.55,25.22,9.86,25.22,9.86s-5.05-8.91-15.01-11.47 c-6.54-1.68-16.41-1.95-24.33,1.27c-8.16,3.31-18.33,12.5-22.01,22.21c-3.67,9.71-5.46,24.83-5.46,24.83L163.65,226.022z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_136_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_137_",
    transform: "matrix(0.9946 -0.1034 0.1034 0.9946 -23.98 17.9882)",
    style: {
      fill: "#56C4F9"
    },
    cx: 161.498,
    cy: 240.27,
    rx: 12.09,
    ry: 18.319
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    style: {
      fill: "#3D86E0"
    },
    d: "M156.231,227.942c4.287-0.644,8.682,4.948,9.815,12.49 c1.133,7.542-1.423,14.179-5.711,14.823c-4.287,0.644-8.682-4.948-9.815-12.49 C149.387,235.223,151.944,228.586,156.231,227.942z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_139_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_140_",
    style: {
      fill: "#3A92C9"
    },
    cx: 201.38,
    cy: 268.922,
    rx: 6.44,
    ry: 4.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    style: {
      fill: "none",
      stroke: "#3A92C9",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M169.03,255.512c0,0,9.46,12.16,25.91,13.41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_142_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_143_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_144_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_145_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_146_",
    style: {
      fill: "#F9A07B"
    },
    d: "M208.44,375.362l-0.62,15.99c0,0-57.83,17.33-67.38,11.85 c-4.66-2.68-9.01-17.42-12.26-31.81c-3.4-15.12-5.58-29.84-5.58-29.84l33.9-6.64c0,0,0.02,20.67,1.17,32.62 c0.41,4.45,1,7.69,1.79,8.22C162.45,377.722,208.44,375.362,208.44,375.362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    style: {
      fill: "#E06A58"
    },
    d: "M157.67,367.512c-6.16,2-18.05,5.09-29.49,3.87 c-3.4-15.12-5.58-29.84-5.58-29.84l33.9-6.64C156.5,334.892,156.52,355.562,157.67,367.512z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_148_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_149_",
    style: {
      fill: "#F9A07B"
    },
    d: "M206.79,375.522c8.6-1.84,23.16-6.26,29.2-7.78 c4.29-1.08,15.46,4.7,18.41,10.15c1.29,2.38,2.51,15.86-1.96,14.47c-2.24-0.7-1.87-6.48-2.57-8.84 c-0.57-1.92-2.39-3.78-5.16-5.38c1.85,4.61,1.78,8.63,1.58,13.61c-0.04,1.1-0.11,2.25-0.64,3.2 c-0.54,0.95-1.7,1.63-2.7,1.21c-1.02-0.42-1.37-1.69-1.6-2.8c-0.79-3.84-1.59-7.68-1.91-12.02 c0.08,4.27-0.01,8.55-0.28,12.81c-0.2,3.26-1.82,5.05-3.81,4.48c-0.89-0.25-1.25-1.07-1.63-2.15 c-0.6,2.09-2.1,4.4-4.04,3.52c-1.18-0.53-1.91-4.79-1.7-9.17c-3.72,2.31-7.92,3.29-12.76,3.51 c-4.34,0.2-8.78-0.61-11.39-3.56C204.09,386.172,205.61,379.352,206.79,375.522z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    style: {
      fill: "none",
      stroke: "#CC454E",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M233.81,395.822 c0.29-3.46-0.01-6.97-0.89-10.31"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    style: {
      fill: "#FFC73C"
    },
    d: "M152.69,301.372c-2.46-6.93-11.47-21.11-11.47-21.11s-13.75,5.72-18.63,15.43 c-8.26,16.44-4.06,63.64-4.06,63.64c11.13,4.66,33.47,4.73,42.98,3.39C161.51,362.722,157.62,315.222,152.69,301.372z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_152_",
    style: {
      fill: "none",
      stroke: "#F2AE30",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M154.44,304.272 c3.75,17.95,5.76,34.69,6.4,51.09"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    x: 54.46,
    y: 405.252,
    style: {
      fill: "#0B2D50"
    },
    width: 394.28,
    height: 9.89
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/ContactUs.ab12e6c0567b5e8610e545c17bd69f1a.svg";
export { ForwardRef as ReactComponent };